@if (notificationData()) {
  @let notification = notificationData()!;
  <div class="notification-banner" [ngClass]="'notification-banner--' + notification.notificationType">
    <dsy-icon class="notification-banner__icon" [name]="notification.notificationType + '-icon'" library="system" size="20px"></dsy-icon>
    <div class="notification-banner__content">
      <h2 class="notification-banner__content-title">
        {{ notification.title }}
      </h2>
      <p class="notification-banner__content-text">
        {{ notification.message }}
      </p>
    </div>

    @if (notification.notificationType !== 'success') {
      <dsy-divider class="notification-banner__divider" divider-orientation="vertical" divider-color="light-grey"></dsy-divider>
      <dr-flex-home-ui-link-button
        class="notification-banner__link"
        [link]="{ text: ('FLEX_HOME.NOTIFICATION_BANNER.MANAGE_DISPATCHES' | translate), href: activeEventsUrl }"
        size="md"
        [mixpanelClickEvent]="mixPanelEvent.CLICK_GO_CTA"
      />
    }
  </div>
} @else {
  <div class="loading-spinner">
    <dsy-loader type="spinner" size="xx-small" animation-speed="slow"></dsy-loader>
  </div>
}
